import { createContext } from "react";
import type { ContentSource } from "@/services/sanity/types";

export interface ContentStatusContextValue {
    activeFallbackMessage?: string;
    clearStatus: (key: string) => void;
    reportStatus: (key: string, source: ContentSource, message?: string) => void;
}

export const ContentStatusContext = createContext<ContentStatusContextValue | null>(null);
